module.exports = __webpack_public_path__ + "img/xunzhang.ec01b49a.png";